import { useSuperQuery } from '@vadiun/react-hooks-legacy';
import { useState } from 'react';
import { PolygonZonesState } from 'shared/models/PolygonZones';
import { SortState } from 'shared/models/tabletReactQuery';
import { polygonZonesService } from 'shared/services/shared/polygonZonesService';

export const getDefaultSortPolygonZones = (): SortState => ({
  sortDir: 'DESC',
  sortBy: 'updated_at',
});

export const getDefaultPolygonZonesState = (): PolygonZonesState => ({
  page: 1,
  rowsPerPage: 10,
  sort: getDefaultSortPolygonZones(),
});

export const usePolygonZones = () => {
  const PolygonZonesService = polygonZonesService();
  const [state] = useState<PolygonZonesState>(getDefaultPolygonZonesState());

  const getPolygonZones = useSuperQuery(
    () =>
      PolygonZonesService.getAll(
        state.page,
        state.rowsPerPage,
        state.sort.sortBy,
        state.sort.sortDir,
      ),
    {
      showSpinner: true,
    },
    [state.page, state.rowsPerPage, state.sort.sortBy, state.sort.sortDir],
  );

  return {
    polygonZones: {
      data: getPolygonZones.data?.rows || [],
      total: getPolygonZones.data?.total || 0,
      isLoading: getPolygonZones.isLoading,
      error: getPolygonZones.error,
      reload: getPolygonZones.reload,
      serverSideOptions: {
        page: state.page - 1,
        count: getPolygonZones.data?.total || 0,
        rowsPerPage: state.rowsPerPage,
        sortOrder: {
          name: state.sort.sortBy,
          direction: state.sort.sortDir.toLowerCase() as 'asc' | 'desc',
        },
      },
    },
  };
};

